export default __webpack_public_path__ + "cdfd7ce9613a61951fd91f21316f836e.png";